import React from "react";
import { Divider } from "@react-md/divider";
import { ListSubheader } from "@react-md/list";
import { defaultTreeItemRenderer } from "@react-md/tree";
/**
 * This is the default navigation item renderer provided by the layout package
 * that has some reasonable defaults for creating a navigation tree. This is
 * just an extension of the base `defaultTreeItemRenderer` from the
 * `@react-md/tree` package that adds in some support for also rendering
 * dividers and subheader elements.
 */
export var defaultNavigationItemRenderer = function (itemProps, item, treeProps) {
    var key = itemProps.key;
    var divider = item.divider, subheader = item.subheader;
    if (divider) {
        return React.createElement(Divider, { key: key });
    }
    if (subheader) {
        return (React.createElement(ListSubheader, { key: key, role: "none" }, item.children));
    }
    return defaultTreeItemRenderer(itemProps, item, treeProps);
};
//# sourceMappingURL=defaultNavigationItemRenderer.js.map